import Ajax from '../common/ajax'

export default {
  model: 'examAudit',
  getPage (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/page`, data)
  },
  getReportPage (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/examReport/page`, data)
  },
  auditReport (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/examReport/audit`, data)
  },
  download (id) {
    return Ajax.get(`/api/gradeMaster/v1/examReport/download/${id}`)
  },
  getFeeInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/examReport/feeInfo/${id}`)
  },
  exportReport (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/examReport/exportExamReport`, data)
  }
}
